const configProd = {
  baseUrl: "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/data",
  errorUrl: "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/error",
  userUrl: "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/user",
  filterUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/filters",
  queryUrl: "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/query",
  dashboardUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/qs",
  alertUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/alerts",
  treatmentPhaseUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/dashboard/treatment-phase",
  latestOutcomeUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/dashboard/latest-outcome",
  drchronoPatientsUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/drchrono-patients",
  clearTmsAnalysisUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/query/clear-tms-analysis",
  patientClaimsMetadataUrl:
    "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/patient-claims-metadata",
  healthCheckUrl: "https://t9mo8clwc4.execute-api.us-west-1.amazonaws.com/prod/health",
  stage: "prod",
};

export const config = configProd;

export const isProdMode = process.env.NODE_ENV === "production";
